import { render, staticRenderFns } from "./PainterSidebar.vue?vue&type=template&id=62fb058f&scoped=true"
import script from "./PainterSidebar.vue?vue&type=script&lang=js"
export * from "./PainterSidebar.vue?vue&type=script&lang=js"
import style0 from "./PainterSidebar.vue?vue&type=style&index=0&id=62fb058f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fb058f",
  null
  
)

export default component.exports